import Guid from "common/values/guid/guid";
import UserCoworker from "users/values/user-coworker/user-coworker";


export default class UserCoworkerAPIResponse {
    memberId?: string;
    entityId?: string;
    entityName?: string;
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    individualId?: string;
    avatarId?: string;

    deserialize(): UserCoworker {
        if (!this.memberId) throw new Error("memberId is required");
        if (!this.entityId) throw new Error("entityId is required");
        if (!this.userId) throw new Error("userId is required");
        if (!this.entityName) throw new Error("entityName is required");
        if (!this.email) throw new Error("email is required");
        if (!this.firstName) throw new Error("firstName is required");
        if (!this.lastName) throw new Error("lastName is required");
        if (!this.individualId) throw new Error("individualId is required");

        return new UserCoworker(
            {
                memberId: new Guid(this.memberId),
                entityId: new Guid(this.entityId),
                entityName: this.entityName,
                userId: new Guid(this.userId),
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                individualId: new Guid(this.individualId),
                avatarId: this.avatarId ? new Guid(this.avatarId) : undefined,
            }
        );
    }
}